import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import TopNav from "../components/TopNav";
import { api } from "../lib/api";

export default function SetupPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState(""); const [pw2, setPw2] = useState("");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);

  if (!token) {
    return <><TopNav/><div className="aa-shell"><h1 className="aa-h1">Invalid link</h1>
      <p className="aa-sub">This setup link is missing or invalid.</p></div></>;
  }

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw.length < 8) { setErr("Password must be at least 8 characters"); return; }
    if (pw !== pw2) { setErr("Passwords don't match"); return; }
    setBusy(true);
    try {
      const r = await api.post("/auth/setup-password", { token, password: pw });
      localStorage.setItem("aabb_token", r.data.access_token);
      localStorage.setItem("aabb_email", r.data.email);
      nav("/account");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed to set password");
    } finally { setBusy(false); }
  };

  return (
    <>
      <TopNav />
      <div className="aa-shell" style={{maxWidth:480}}>
        <div className="aa-eyebrow">Welcome</div>
        <h1 className="aa-h1">Set your password</h1>
        <p className="aa-sub">Choose a strong password to access your account.</p>
        <form onSubmit={submit}>
          <label className="aa-label">Password</label>
          <input className="aa-input" type="password" value={pw} onChange={(e)=>setPw(e.target.value)} data-testid="setup-pw"/>
          <div style={{height:12}}/>
          <label className="aa-label">Confirm password</label>
          <input className="aa-input" type="password" value={pw2} onChange={(e)=>setPw2(e.target.value)} data-testid="setup-pw2"/>
          {err && <div className="aa-error" data-testid="setup-error">{err}</div>}
          <div className="aa-bottom"><button className="aa-btn" disabled={busy} data-testid="setup-submit">{busy?"Setting…":"Set password"}</button></div>
        </form>
      </div>
    </>
  );
}
